"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createVisualizationAdapter = exports.createAdapterConfig = void 0;
var _react = _interopRequireDefault(require("react"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _ReactBase = require("./React/ReactBase");
var _Three2DLayers = require("./Three/Three2DLayers");
var _Three3DScene = require("./Three/Three3DScene");
var _Three2D = require("./Three/Three2D");
var _Three3D = require("./Three/Three3D");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var createVisualizationAdapter = exports.createVisualizationAdapter = function createVisualizationAdapter(adapterConfig, target) {
  var cfg = adapterConfig[target];
  if (!cfg) {
    throw new Error("No adapter configuration for the following target: ".concat(target));
  }
  var Adapter = cfg.adapterClass;
  if (Adapter) {
    return new Adapter(cfg);
  }
};
var createAdapterConfig = exports.createAdapterConfig = function createAdapterConfig(_ref) {
  var host = _ref.host;
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _merge["default"])({
    "2dVariant": {
      adapterClass: _Three2D.Three2D,
      modelBasePath: host,
      basePath: "".concat(host, "/images/item/view") // only for conventional urls
    },

    "2dVariantOverlay": {
      adapterClass: _Three2D.Three2D,
      modelBasePath: host,
      basePath: "".concat(host, "/images/item/view") // only for conventional urls
    },

    "2dLayer": {
      adapterClass: _Three2DLayers.Three2DLayers,
      modelBasePath: host
    },
    "3dVariant": {
      adapterClass: _Three3DScene.Three3DScene,
      modelBasePath: host
    },
    "3dScene": {
      adapterClass: _Three3DScene.Three3DScene,
      modelBasePath: host
    },
    "3d": {
      // deprecated, only for backward compatibility
      adapterClass: _Three3D.Three3D,
      modelBasePath: host
    },
    "default": {
      adapterClass: _ReactBase.ReactBase,
      Component: function Component() {
        return /*#__PURE__*/_react["default"].createElement("div", null, "No visualization");
      }
    }
  }, overrides);
};